/*
 * Jira Ticket:
 * Created Date: Mon, 23rd Mar 2020, 11:37:54 am
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import React, { cloneElement, useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
  TopToolbar,
  sanitizeListRestProps,
  useDataProvider,
} from 'react-admin';
import { Help } from '@material-ui/icons';
import { ActionButton } from 'Components/Buttons';
import getHelp from '../../utils/getHelp';
import { LinkButton } from 'Components/Buttons';
import { Add } from '@material-ui/icons';

const UserActions = ({
  currentSort,
  className,
  resource,
  filters,
  displayedFilters,
  exporter, // you can hide ExportButton if exporter = (null || false)
  filterValues,
  permanentFilter,
  hasCreate, // you can hide CreateButton if hasCreate = false
  basePath,
  selectedIds,
  onUnselectItems,
  showFilter,
  maxResults,
  total,
  organisationId,
  ...rest
}) => {
  const dataProvider = useDataProvider();
  const dispatch = useDispatch();
  const [helpLink, setHelpLink] = useState();

  const useMountEffect = fun => useEffect(fun, []);

  useMountEffect(
    getHelp('help_url_user', { dataProvider, dispatch, setHelpLink })
  );

  return (
    <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
      {helpLink && (
        <ActionButton
          label="resources.General.help"
          variant="text"
          onClick={() => {
            window.open(helpLink);
          }}
          icon={<Help />}
        />
      )}
      {filters &&
        cloneElement(filters, {
          resource,
          showFilter,
          displayedFilters,
          filterValues,
          context: 'button',
        })}
      <LinkButton
        name={'actions.invite'}
        pathname={'/Employment/create'}
        icon={<Add />}
      />
    </TopToolbar>
  );
};

UserActions.defaultProps = {
  selectedIds: [],
  onUnselectItems: () => null,
};

export default UserActions;
